/* eslint-disable no-underscore-dangle */
import { useAnalyticsEffect } from './useAnalyticsEffect';
import useFirebaseEffect from './useFirebaseEffect';

const injectDebugHelpers = ({ currentUser }: { currentUser: unknown }) => {
  globalThis.___tt___ = globalThis.___tt___ ?? {};
  globalThis.___tt___.currentUser = currentUser;
};

const injectEnvs = ({ env }: { env: Record<string, string> }) => {
  globalThis.env = env as Record<string, string>;
};

const useAppLaunchEffect = (context: {
  env: Record<string, string>;
  currentUser: unknown;
  isMobile: boolean;
  serverTime: number;
}) => {
  injectEnvs(context);
  // TODO: Remove firebase. We don't need it.
  useFirebaseEffect(context);
  useAnalyticsEffect({ env: context.env, currentUser: context.currentUser });
  injectDebugHelpers(context);
};

export default useAppLaunchEffect;
